"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var GameSetGamesBotWinsListCtl = /** @class */ (function (_super) {
    __extends(GameSetGamesBotWinsListCtl, _super);
    function GameSetGamesBotWinsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_win_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_type_code; });
        _this.dk_win_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_type_title; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_win_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.win_amount; });
        _this.dk_spin_count_next = UIUtils_1.UIUtils.IProp2Str(function (o) { o.spin_count_next; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    GameSetGamesBotWinsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    GameSetGamesBotWinsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "gameset with id [" + id + "] not found !";
    };
    GameSetGamesBotWinsListCtl.prototype.LoadData = function (GameproviderGamesetGame_id, onDone) {
        var _this = this;
        webAApi_1.ListGameSetGameBotWinsByGameIdGet.exec({
            gameprovider_gameset_game_id: GameproviderGamesetGame_id
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    win_type_code: resp.list[i].win_type_code,
                    win_type_title: resp.list[i].win_type_title,
                    win_amount: resp.list[i].win_amount,
                    spin_count_next: resp.list[i].spin_count_next,
                    app_currency_title: resp.list[i].app_currency_title,
                    description: resp.list[i].description,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetGamesBotWinsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddGameSetGameBotWin.exec({
            data: {
                gameprovider_gameset_game_id: data.gameprovider_gameset_game_id,
                description: data.description,
                win_type_code: data.win_type_code,
                win_amount: data.win_amount,
                spin_counts_next: data.spin_counts_next,
                app_currency_id: data.app_currency_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                spin_count_next: data.spin_counts_next,
                description: data.description,
                win_amount: data.win_amount,
                app_currency_title: resp.app_currency_title,
                win_type_code: data.win_type_code,
                win_type_title: resp.win_type_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetGamesBotWinsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditGameSetGameBotWin.exec({
                data: {
                    cms_gameset_game_botwin_id: data.key,
                    win_type_code: data.win_type_code,
                    description: data.description,
                    win_amount: data.win_amount,
                    spin_counts_next: data.spin_counts_next
                }
            }, function (resp) {
                _tmp.win_type_code = data.win_type_code;
                _tmp.win_type_title = resp.win_type_title;
                _tmp.description = data.description;
                _tmp.win_amount = data.win_amount;
                _tmp.spin_count_next = data.spin_counts_next;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetGamesBotWinsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    GameSetGamesBotWinsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteGameSetGameBotWin.exec({
                data: {
                    cms_gameset_game_botwin_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return GameSetGamesBotWinsListCtl;
}(BaseController_1.BaseController));
exports.GameSetGamesBotWinsListCtl = GameSetGamesBotWinsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ctl/GameSetGamesBotWinsListCtl.ts
// module id = 1023
// module chunks = 0